<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          class="tab-text"
          v-for="(item,index) in bankCollectionList"
          :key="index"
        ></el-tab-pane>
      </el-tabs>
      <finance-seach
        :column-option="bankCollectionOptionList"
        @onSearch="getList"
        ref="clearSeachInfo"
        :timer-array="['processDate','recevieDate']"
        :expression-array="['receiptMoney']"
      >
        <div class="search_rightitem" v-show="activeName==='1' || activeName==='2'">
          <el-button type="primary" @click="addNewBlank">新增</el-button>
          <el-button
            plain
            v-show="activeName==='1'"
            :disabled="!list.length"
            @click="batchClaim"
          >批量领取</el-button>
          <el-button
            plain
            v-show="activeName === '2'"
            :disabled="!list.length"
            @click="batchPass"
          >批量通过</el-button>
          <el-button plain v-show="activeName === '1'" @click="leadInProduct">导入收款记录</el-button>
        </div>
      </finance-seach>
      <div class="box-table" :style="{height: financeTableHeight + 'px'}">
        <el-row style="margin-bottom:20px;" v-if="activeName ==='收款记录'">
          <el-col :span="4">
            待审核付款申请：
            <span style="color:#D35E5E;">{{total}}条</span>
          </el-col>
          <el-col :span="4">
            付款总额：
            <span style="color:#D35E5E;">{{ totalPrice | showPrice}}元</span>
          </el-col>
        </el-row>
        <el-table
          border
          type="reset"
          ref="tableRef"
          :data="list"
          :max-height="financeTableHeight"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            :key="1"
            :selectable="selectTableFun"
            v-if="activeName === '1' || activeName === '2'"
          ></el-table-column>
          <el-table-column label="收款编号" :key="2" v-if="activeName==='3' || activeName=='4'">
            <template slot-scope="scope">
              <span class="approval" @click="onDetails(scope.row)">{{scope.row.receiptNumber}}</span>
            </template>
          </el-table-column>
          <el-table-column :key="3" prop="receiptNumber" label="收款编号" v-else></el-table-column>
          <el-table-column :key="4" prop="payBankNumber" label="付款人银行账号"></el-table-column>
          <el-table-column :key="5" prop="payName" label="付款人账户名"></el-table-column>
          <el-table-column prop="payOpenBank" label="付款人开户行名称" :key="6"></el-table-column>

          <el-table-column :key="7" prop="payBankCode" label="银行行号"></el-table-column>
          <el-table-column :key="8" prop="receiptBankNumber" label="收款银行账号"></el-table-column>
          <el-table-column :key="9" prop="receiptName" label="收款人名称"></el-table-column>
          <el-table-column :key="10" prop="receiptOpenBank" label="收款人开户行名称"></el-table-column>
          <el-table-column :key="11" prop="flowCode" label="交易流水号"></el-table-column>
          <el-table-column :key="12" prop="receiptMoney" label="收款金额">
            <template v-slot="{row}">{{row.receiptMoney | toFixed}}</template>
          </el-table-column>
          <el-table-column :key="13" prop="receiptType" label="收款类型">销售货款</el-table-column>
          <el-table-column :key="14" prop="payMethod" label="收款方式">银行转账</el-table-column>
          <el-table-column
            :key="15"
            prop="otherCollection"
            label="是否存在其他收款申请"
            v-if="activeName==='2' "
          ></el-table-column>
          <el-table-column :key="16" prop="tradeDate" label="交易时间">
            <template slot-scope="scope">{{ scope.row.tradeDate | dateFilter }}</template>
          </el-table-column>
          <el-table-column :key="17" prop="createUser" label="添加人"></el-table-column>
          <el-table-column :key="18" prop="createDate" label="添加时间">
            <template slot-scope="scope">{{ scope.row.createDate | dateFilter }}</template>
          </el-table-column>
          <el-table-column :key="19" prop="userName" label="负责人" v-if="activeName === '1'">
            <template v-slot="{row}">{{row.userName || '--'}}</template>
          </el-table-column>
          <el-table-column :key="20" prop="recevieUser" label="认领人" v-if="activeName === '1' ">
            <template v-slot="{row}">{{row.recevieUser || '--'}}</template>
          </el-table-column>

          <el-table-column
            :key="21"
            prop="recevieDate"
            label="认领时间"
            v-if="activeName ==='1' || activeName === '2'"
          >
            <template v-slot="{row}">{{row.recevieDate | dateFilter}}</template>
          </el-table-column>
          <!--              <el-table-column-->
          <!--                prop="processSecUser"-->
          <!--                v-if="activeName !== '4'"-->
          <!--                label="领取人"-->
          <!--                :key="21"-->
          <!--              ></el-table-column>-->
          <!--              <el-table-column :key="22" prop="auditUser" label="审核人" v-if="activeName==='4'"></el-table-column>-->
          <el-table-column
            :key="23"
            prop="recevieUser"
            label="处理人"
            v-if="activeName==='3' || activeName ==='4'"
          ></el-table-column>

          <el-table-column
            :key="24"
            prop="recevieDate"
            label="处理时间"
            v-if="activeName==='3' || activeName ==='4'"
          >
            <template v-slot="{row}">{{row.recevieDate | dateFilter}}</template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" v-if="activeName==='1' ">
            <template slot-scope="scope">
              <el-button type="text" @click="onClaim(scope.row)" v-if="scope.row.extract === 1">认领</el-button>
              <el-button type="text" @click="onExtract(scope.row)" v-if="scope.row.extract ===3">提取</el-button>
              <el-button type="text" v-if="scope.row.extract === 2" @click="deleBtn(scope.row)">处理</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" v-if="activeName==='2' ">
            <template slot-scope="scope">
              <el-button type="text" @click="deleBtn(scope.row)">处理</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <pagination
          :total="total"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
    <lead-in ref="leadInRefs" @onRefresh="onRefresh"></lead-in>
    <base-dialog :dialog-visible.sync="dialogVisible" :title="`提交确认`" :disableds='submitDisabled' @successEv="sucBatchEv">
      <div style="padding:0 30px;">
        <div>确定收款：{{chioesList.length}}条申请；总计收款金额：{{allAmount}}</div>
        <p class="pb20">确定提交收款？提交后无法撤回，请谨慎操作</p>
      </div>
    </base-dialog>

    <base-dialog
      :dialog-visible.sync="addNewBlankVisible"
      :width="`780px`"
      :title="`新增`"
      :succlosedialog="false"
      @successEv="submitAddFrom"
      @closedialogVisibale="closedialogVisibale"
      @closeDialog="closeDialog"
    >
      <template>
        <el-form :model="addFrom" :rules="addRules" ref="addRefs" style="padding-right: 10px;">
          <el-row>
            <el-col :span="12">
              <el-form-item label="付款人账户名称：" prop="cusObj" label-width="145px">
                <el-select
                  filterable
                  value-key="id"
                  v-model="addFrom.cusObj"
                  @change="loadCustomerAccount"
                >
                  <el-option
                    v-for="item in allCustomer"
                    :key="item.id"
                    :label="item.cusName"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="负责人：" prop="userName" label-width="145px">
                <el-input disabled v-model="addFrom.userName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="付款人银行账号：" prop="customerAccount" label-width="145px">
                <el-select
                  value-key="bankCode"
                  @change="loadAccountInfo"
                  v-if="accountArray.length"
                  v-model="addFrom.customerAccount"
                >
                  <el-option
                    v-for="item in accountArray"
                    :key="item.id"
                    :label="item.bankAccount"
                    :value="item"
                  ></el-option>
                </el-select>
                <el-input v-else v-model="addFrom.customerAccount.bankAccount"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="付款人开户行名称：" prop="bankOpencount" label-width="145px">
                <el-input :disabled="Boolean(accountArray.length)" v-model="addFrom.bankOpencount"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="银行行号：" prop="fbankCode" label-width="145px">
                <el-input :disabled="Boolean(accountArray.length)" v-model="addFrom.fbankCode"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="收款银行账号：" prop="bankObj" label-width="145px">
                <el-select v-model="addFrom.bankObj" value-key="id" @change="setBankAccount">
                  <el-option
                    v-for="item in financeBankList"
                    :key="item.id"
                    :label="item.bankCode"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="收款人账户名：" prop="bankUserName" label-width="145px">
                <el-input v-model="addFrom.bankUserName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="收款人开户行名称：" prop="bankOpenName" label-width="145px">
                <el-input v-model="addFrom.bankOpenName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="交易流水号：" prop="transactionSerialNumber" label-width="145px">
                <el-input v-model.trim="addFrom.transactionSerialNumber"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="交易时间：" prop="transactionHour" label-width="145px">
                <el-date-picker
                  style="width: 100%"
                  v-model="addFrom.transactionHour"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  :picker-options="pickerOptions"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="收款金额：" prop="amountReceived" label-width="145px">
                <el-input v-model.trim="addFrom.amountReceived"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </base-dialog>
  </div>
</template>
<script>
import { expressionList } from '@/components/utils/data'
import pagination from '@/components/pagination'
import { formatDate, isSuccess } from '@/util/tool'
import {
  bankCollectionList,
  bankCollectionListex,
  bankDrafmonery
} from '../financeManage/util/data'
import {
  addbankBill,
  financeBankInfo,
  getAccountByCustomerId,
  getAllCustomer,
  queryBankInfoListByState,
  updateStateByFbrId
} from '@/api/fiance/fianceManage'
import financeSeach from '@/components/module/financeSeach'
import { mapState } from 'vuex'
import leadIn from '@/components/leadIn/index'
import { deepClone } from '@/util'

export default {
  components: {
    leadIn,
    pagination: pagination,
    financeSeach
  },

  data() {
    return {
      submitDisabled: false,
      allCustomer: [],
      accountArray: [],
      financeBankList: [],
      miState: 0,
      activeName: '', // tabs选中状态
      bankCollectionList: bankCollectionList, // tabs状态
      loadingTable: false, // 列表loading
      list: [], // 列表数据
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      totalPrice: 0, // 总价
      queryParams: {}, // 搜索条件
      params: {},
      bankDrafmonery: bankDrafmonery,
      bankCollectionOptionList: bankCollectionListex, // 筛选条件
      expressionList: expressionList,
      checked: false,
      value1: '',
      value2: '',
      chioesList: [],
      dialogVisible: false,
      allAmount: 0,
      preParams: '',
      addNewBlankVisible: false,
      addFrom: {
        customerAccount: {},
        transactionHour: formatDate(new Date(), 'yyyy-MM-dd hh:mm')
        // bankObj: {}
      },
      pickerOptions: {},
      addRules: {
        cusObj: [
          {
            required: true,
            message: '请选择付款人账户名称',
            trigger: 'change'
          }
        ],
        // customerAccount: [
        //   {
        //     required: true,
        //     message: '请选择付款人银行账户',
        //     trigger: 'change'
        //   }
        // ],
        // bankOpencount: [
        //   {
        //     required: true,
        //     message: '请输入付款人开户行名称',
        //     trigger: 'blur'
        //   }
        // ],
        // fbankCode: [
        //   {
        //     required: true,
        //     message: '请输入银行行号',
        //     trigger: 'blur'
        //   }
        // ],
        bankObj: [
          {
            required: true,
            message: '请选择收款银行账户',
            trigger: 'change'
          }
        ],
        bankUserName: [
          {
            required: true,
            message: '请输入收款账户名',
            trigger: 'blur'
          },
          {
            required: true,
            message: '请输入收款账户名',
            trigger: 'change'
          }
        ],
        bankOpenName: [
          {
            required: true,
            message: '请输入开户行名称',
            trigger: 'blur'
          },
          {
            required: true,
            message: '请输入开户行名称',
            trigger: 'change'
          }
        ],
        // transactionSerialNumber: [
        //   {
        //     required: true,
        //     message: '请输入交易流水号',
        //     trigger: 'change'
        //   }
        // ],
        transactionHour: [
          {
            required: true,
            message: '请输入交易时间',
            trigger: 'blur'
          }
        ],
        amountReceived: [
          {
            required: true,
            validator(rule, value, callback) {
              const str = /(^[¥]?[1-9]\d{0,2}($|(,\d{3})*($|(\.\d{1,2}$))))|((^[0](\.\d{1,2})?)|(^[¥][0]\.\d{1,2}))$/
              const str1 = /^([1-9]+[\d]*(.[0-9]{1,2})?)$/
              if (str.test(value)) {
                callback()
              } else if (str1.test(value)) {
                callback()
              } else {
                callback(new Error('请输入正确的金额'))
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.activeName = '1'
    this.getList()
    this.getAllCustomer()
    this.financeBankInfo()
  },
  computed: {
    ...mapState(['financeTableHeight'])
  },
  watch: {
    activeName(newVal) {
      switch (newVal) {
        case '1':
          this.bankCollectionOptionList = [
            ...bankCollectionListex,
            {
              label: '认领人',
              value: 'recevieUser'
            },
            {
              label: '认领时间',
              value: 'recevieDate'
            }
          ]
          break
        case '2':
          this.bankCollectionOptionList = [
            ...bankCollectionListex,
            {
              label: '认领时间',
              value: 'recevieDate'
            }
          ]
          break
        case '3':
          this.bankCollectionOptionList = [
            ...bankCollectionListex,
            {
              label: '处理人',
              value: 'recevieUser'
            },
            {
              label: '处理时间',
              value: 'recevieDate'
            }
          ]
          break
        case '4':
          this.bankCollectionOptionList = [
            ...bankCollectionListex,
            {
              label: '处理人',
              value: 'recevieUser'
            },
            {
              label: '处理时间',
              value: 'recevieDate'
            }
          ]
          break
      }
      return newVal
    }
  },
  filters: {
    dateFilter,
    showPrice(totalPrice) {
      return totalPrice.toFixed(2)
    },
    payType(payType) {
      if (payType === 1) {
        return '客户提现'
      } else if (payType === 2) {
        return '采购付款'
      } else if (payType === 3) {
        return '供应商充值'
      } else if (payType === 4) {
        return '退货罚没金'
      } else if (payType === 5) {
        return '维修付款'
      } else if (payType === 7) {
        return '采购退货罚款'
      }
    }
  },
  methods: {
    closedialogVisibale() {
      this.accountArray = []
      this.$refs.addRefs.resetFields()
    },
    closeDialog() {
      this.accountArray = []
      this.$refs.addRefs.resetFields()
    },
    setBankAccount() {
      const { bankObj } = this.addFrom
      Object.assign(this.addFrom, bankObj)
    },
    submitAddFrom() {
      this.$refs.addRefs.validate((vaildate) => {
        if (vaildate) {
          const {
            cusObj,
            transactionSerialNumber,
            customerAccount,
            bankObj,
            amountReceived,
            transactionHour
          } = this.addFrom
          addbankBill(
            {
              confirmDate: '',
              confirmMark: '',
              confirmState: 0,
              createDate: '',
              createIp: 0,
              createUser: '',
              cusId: cusObj.id,
              flowCode: transactionSerialNumber,
              id: 0,
              mark: '',
              payBankCode: customerAccount.bankCode,
              payBankNumber: customerAccount.bankAccount,
              payMethod: 0,
              payName: cusObj.cusName,
              payOpenBank: customerAccount.bankOpencount,
              receiptBankCode: '',
              receiptBankNumber: bankObj.bankCode,
              receiptMoney: amountReceived,
              receiptName: bankObj.bankUserName,
              receiptNumber: '',
              receiptOpenBank: bankObj.bankOpenName,
              receiptType: '',
              recevieDate: '',
              recevieId: 0,
              recevieState: 0,
              recevieUser: '',
              tradeDate: new Date(transactionHour)
            },
            bankObj.id
          ).then((res) => {
            if (isSuccess(res)) {
              this.$message.success('新增成功')
              this.addNewBlankVisible = false
              this.closeDialog()
              this.getList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    },
    financeBankInfo() {
      financeBankInfo().then((res) => {
        if (isSuccess(res)) {
          this.financeBankList = res.data.obj
        }
      })
    },
    loadAccountInfo() {
      const { customerAccount } = this.addFrom
      customerAccount.fbankCode = customerAccount.bankCode
      Object.assign(this.addFrom, customerAccount)
      this.addFrom = deepClone(this.addFrom)
    },
    onRefresh() {
      this.getList()
    },
    leadInProduct() {
      this.$axios.post('/api/SystemOpenController/queryFinacebankreceipt').then((res) => {
        if (isSuccess(res)) {
          this.$refs.leadInRefs.onLeadIn(
            this.$store.state.financialAffairsCuidIn,
            '财务-银行收款导入'
          )
        } else {
          this.$message.error('暂无权限')
        }
      })
    },
    batchClaim() {
      if (this.chioesList.length === 0) {
        this.$message.error('请选择一条或多条！')
      } else {
        var list = []
        this.chioesList.forEach((item) => {
          list.push(item)
        })
        updateStateByFbrId(null, list, 2, 'updateStateByFbrIdClaimAll')
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success('认领成功！')
              this.getList()
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    batchPass() {
      this.allAmount = 0
      if (this.chioesList.length === 0) {
        this.$message.error('请选择一条或多条！')
      } else {
        this.chioesList.forEach((item) => {
          this.allAmount += item.receiptMoney
        })
        this.dialogVisible = true
      }
    },
    sucBatchEv() {
      this.submitDisabled = true
      updateStateByFbrId(2, this.chioesList, '', 'updateStateByFbrIdAll').then((res) => {
        if (isSuccess(res)) {
          this.$message.success('操作成功')
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
        this.submitDisabled = false
      })
    },
    selectTableFun(row) {
      return (
        (row.recevieState === 1 && this.activeName === '1') ||
        (row.recevieState === 2 && this.activeName === '2')
      )
    },
    // 重置
    searchReset() {
      this.params = {}
      this.queryParams = {}
      this.getList()
    },
    // 搜索
    onSearch() {
      if (this.time && this.time.length === 2) {
        this.params.value = this.time[0]
        this.params.endValue = this.time[1]
      }
      if (this.params.value === '' || this.params.value === undefined) {
        this.$message.error('搜索条件不能为空')
      } else {
        this.getList()
      }
    },
    // 审批
    approval() {},
    // 收款申请详情
    onDetails(row) {
      if (this.activeName === '审核不通过') {
        this.$router.push({
          name: 'passList',
          query: { fprsId: row.id }
        })
      } else {
        this.$router.push({
          name: 'CollectionList',
          query: { fprsId: row.id }
        })
      }
    },
    // 已处理
    onHandle(row) {},
    // 处理
    deleBtn(row) {
      this.$router.push({
        name: 'dealList',
        query: { fprsId: row.id }
      })
    },
    // 待认领
    onClaim(row) {
      updateStateByFbrId(null, [row], 2, 'updateStateByFbrIdClaim').then((res) => {
        if (isSuccess(res)) {
          this.$message.success('认领成功')
          this.getList()
        }
      })
    },
    // 提取
    onExtract(row) {
      updateStateByFbrId(null, [row], 1, 'updateStateByFbrIdExtract').then((res) => {
        if (isSuccess(res)) {
          this.$message.success('提取成功')
          this.getList()
        }
      })
    },
    // tabs切换时触发的事件
    handleClick(tab) {
      this.currentPage = 1
      this.activeName = tab.name
      this.$refs.clearSeachInfo.innerInit()
      this.getList()
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 列表数据
    getList(list) {
      this.loadingTable = true
      if (this.activeName === '1') {
        this.miState = 1
      } else if (this.activeName === '2') {
        this.miState = 2
      } else if (this.activeName === '3') {
        this.miState = 3
      } else if (this.activeName === '4') {
        this.miState = 4
      }
      const params = {
        criteriaVoList: list || this.preParams || [],
        queryPageName: ''
      }
      if (list) {
        this.currentPage = 1
      }
      queryBankInfoListByState(this.miState, this.currentPage, this.pageSize, params)
        .then((res) => {
          if (res.data.code === 200) {
            this.preParams = list
            if (res.data.obj.records.length === 0) {
              this.loadingTable = false
              this.list = []
            } else {
              this.totalPrice = 0
              this.loadingTable = false
              this.list = res.data.obj.records[0].finaceBankReceiptListVoList
              this.list.forEach((ele) => (this.totalPrice += ele.receiptMoney))
              this.total = res.data.obj.total
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 页数
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },

    handleSelectionChange(val) {
      this.chioesList = val
    },
    addNewBlank() {
      this.addNewBlankVisible = true
      this.addFrom.transactionHour = formatDate(new Date(), 'yyyy-MM-dd hh:mm')
      this.addFrom = deepClone(this.addFrom)
    },
    loadCustomerAccount(val) {
      this.addFrom.userName = val.userName
      console.log(val, this.addFrom.userName)
      Object.assign(this.addFrom, {
        customerAccount: {},
        bankOpencount: '',
        fbankCode: ''
      })
      this.addFrom = deepClone(this.addFrom)
      getAccountByCustomerId({
        cusId: this.addFrom.cusObj.id
      }).then((res) => {
        if (isSuccess(res)) {
          this.accountArray = res.data.obj
          // this.addFrom.userName =
        }
      })
    },
    getAllCustomer() {
      getAllCustomer({
        criteriaVoList: [
          {
            collection: true,
            column: 'cusName',
            endValue: '',
            expression: '',
            value: '',
            valueType: ''
          }
        ],
        queryPageName: ''
      }).then((res) => {
        if (isSuccess(res)) {
          this.allCustomer = res.data.obj
        }
      })
    }
  }
}

function dateFilter(time) {
  if (!time) return '--'
  const date = new Date(time)
  return formatDate(date, 'yyyy-MM-dd hh:mm')
}
</script>
